<app-side-dialog [disableClose]="true" (closeDialog)="onCloseClick()">
  <div dialogHeader>
    <h2>{{ 'pages.settings.userManagement.selectTeamDialog.title' | translate }}</h2>
  </div>

  <div dialogContent class="flex flex-col">
    <div class="flex flex-col gap-2">
      @for (team of data.teams; track team.id) {
        <button
          type="button"
          class="w-full flex items-center justify-between gap-3 rounded-full border border-shikenso-purple-base-12 p-1 pr-2 text-left hover:bg-shikenso-pink-base-12"
          [class.bg-shikenso-pink-base-40]="selectedTeamId() === team.id"
          [disabled]="submitLoading()"
          (click)="onTeamClick(team)"
        >
          <div class="flex items-center gap-3 min-w-0">
            <app-icon-badge
              color="var(--shikenso-purple-base)"
              backgroundColor="var(--shikenso-pink-100-40)"
              [content]="team.iconId"
              [fallbackText]="team.name"
              [borderRadius]="100"
              [size]="40"
              [iconSize]="40"
              [fontSize]="16"
            />
            <span class="text-sm">{{ team.name }}</span>
          </div>

          @if (selectedTeamId() === team.id) {
            <app-icon src="/icons/circle-check.svg" [size]="20" color="var(--shikenso-pink-base)" alt="Selected" />
          }
        </button>
      }
    </div>

    <button
      type="button"
      *hasPermission="EPermissions.teamCreate"
      class="w-full flex items-center justify-center gap-2 rounded-full border border-shikenso-purple-base-12 px-4 py-3 mt-4"
      [disabled]="submitLoading()"
      (click)="onAddTeamClick()"
    >
      <app-icon src="/icons/plus.svg" [size]="16" alt="" />
      <span class="text-sm">{{ 'pages.settings.userManagement.selectTeamDialog.addTeam' | translate }}</span>
    </button>

    <div class="flex justify-end gap-3 mt-6">
      <button mat-button [disabled]="submitLoading()" (click)="onCloseClick()">
        {{ 'shared.cancel' | translate }}
      </button>
      <button mat-flat-button color="primary" [disabled]="submitLoading()" (click)="onSaveClick()">
        <p [class.hidden]="submitLoading()">{{ 'shared.save' | translate }}</p>

        @if (submitLoading()) {
          <app-dots-spinner />
        }
      </button>
    </div>
  </div>
</app-side-dialog>
